import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import cancelled from "../../assets/orders/cancelled.png";
import stepsCompleted from "../../assets/orders/stepsCompleted.png";
import note from "../../assets/preview/note.png";
import { Link } from "react-router-dom";
import { CheckCircleFilled, DownOutlined, UpOutlined } from "@ant-design/icons";
import { Carousel, Collapse, Input, Modal, Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const Cancelled = ({ idOrder }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const [collapsed, setCollapsed] = useState(false);
  let [open, setOpen] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    {
      collapsed ? (
        <DownOutlined className="text-[#EAA182]" />
      ) : (
        <UpOutlined className="text-[#EAA182]" />
      );
    }
  };
  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <UpOutlined className="plus-icon text-[#EAA182]" />
    ) : (
      <DownOutlined className="plus-icon text-[#EAA182]" />
    );

  const dispatch = useDispatch();
  const { order, status, error } = useSelector((state) => state.order);

  useEffect(() => {
    dispatch(fetchOrderById(idOrder));
  }, [dispatch]);

  const items = [
    {
      key: "1",
      label: t("Order Details"),
      children: (
        <div>
          {/* <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg">
            <h3 className="text-[#525D71] text-xl">Confirmed Pricing</h3>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[#A4ADBC] mt-3">Price</p>
                <p className="text-[#FE9B71]">{order?.clear_price} SAR</p>
              </div>
              <div>
                <p className="text-[#A4ADBC] mt-3">Wallet</p>
                <p className="text-[#FE9B71]">{order?.wallet_pay} SAR</p>
              </div>
            </div>
          </div> */}

          <div className="px-5">
            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={calender}
                  className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">
                  {order?.date} | {order?.time}
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img
                  src={address}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">{order?.address}</p>
              </div>
            </div>

            <div className="flex items-start mt-5 ">
              <img
                src={desc}
                className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
              />
              <p className="text-[#283D63] font-medium">{order?.description}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={upload}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                {order?.uploaded_images?.length > 0 ? (
                  <>
                    <button
                      onClick={showModalView}
                      className="text-[#6682B6] underline font-medium"
                    >
                      {t("View Uploaded Images")}
                    </button>
                    <Modal
                      title={t("Uploaded Images")}
                      className="orderModal orderModalPricing w_small_modal"
                      open={isModalView}
                      onOk={handleOkView}
                      onCancel={handleCancelView}
                      footer={null}
                    >
                      <Carousel
                        arrows
                        infinite={false}
                        className="custome_carousel_images"
                      >
                        {order?.uploaded_images?.map((img, index) => (
                          <div key={index}>
                            <img
                              src={`https://service.samoolah.com/${img}`}
                              alt={`Uploaded image ${index + 1}`}
                              className="w-[120px] mx-auto my-5"
                            />
                          </div>
                        ))}
                      </Carousel>
                    </Modal>
                  </>
                ) : (
                  <p className="text-[#283D63] font-medium">
                    {t("No Uploaded Images")}
                  </p>
                )}
              </div>
              <div className="flex items-center mt-3 ">
                <img src={statusIcon} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">{t("Status")}</p>
                <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>{t("Cancelled")}</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const formatDateTime = (dateString) => {
    const dateObject = new Date(dateString);
    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const year = dateObject.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const hours = String(dateObject.getHours()).padStart(2, "0");
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");

    const formattedTime = `${hours}:${minutes}`;

    return { formattedDate, formattedTime };
  };

  const { formattedDate, formattedTime } = formatDateTime(order?.updated_at);

  return (
    <div>
      <div className="mx-auto text-center">
        <img src={cancelled} className="w-[50px] mx-auto my-5" />
        <p className="text-[#525D71] font-semibold">{t("Order Cancelled")}</p>
      </div>
      <div className="my-5 mx-auto">
        <img
          src={`https://service.samoolah.com/${order?.category?.icon}`}
          className="w-[120px] mx-auto bg-[#FCFBFA] rounded-2xl p-3"
        />
      </div>

      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
          {t("Order number")}
          <span className="text-[#283D63] font-semibold">#{order?.id}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
          {t("Order created on")} {formattedDate} <br /> {formattedTime}
        </p>
      </div>

      <div className="flex items-center my-5">
        <img src={note} className="w-[35px]" />
        <p className={`text-[#737E91] text-lg ${language == "en" ? "ml-4" : "mr-4"} font-medium`}>
          {t("Order was cancelled on pending status")}
        </p>
      </div>

      <Collapse
        defaultActiveKey={["1"]}
        inlineCollapsed={collapsed}
        items={items}
        expandIcon={customExpandIcon}
        expandIconPosition="right"
        bordered={false}
        className="bg-white custom_collapse"
      />

      {/* <div className="mt-3">
        <h3 className="text-[#14294F] text-xl font-semibold">
          Rate Service Provided
        </h3>
        <p className="text-[#42567B] mt-4 text-center font-semibold">
          How satisfied are you with the service provided?
        </p>
        <Rate
          allowHalf
          defaultValue={0}
          className="mx-auto flex justify-center mt-3"
        />
        <p className="text-[#42567B] mt-5 text-center">
          Do you have any reviews or suggestions that you’d like to share?
        </p>
        <div className="lg:mx-10">
          <TextArea
            placeholder="Type in here your review / suggestions ……"
            allowClear
            onChange={onChange}
            className="w-full my-4 border-0 h-[100px] rounded-3xl"
          />
        </div>

        <div>
          <button
            onClick={showModal}
            className="bg-[#FE9B71] text-white rounded-full px-14 py-3 text-lg mx-auto flex"
          >
            Submit
          </button>
          <Modal
            title=""
            className="orderModal orderModalPricing w_small_modal"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
          >
            <div className="mt-6">
              <p className="text-[#14294F] text-center font-bold text-xl">
                Your feed back has been submitted <br /> Successfully
              </p>
              <p className="text-[#A6ADB9] text-center text-lg my-4">
                Thanks for giving the time to rate our services.
              </p>
              <button className="bg-[#FE9B71] text-white rounded-full px-10 py-2 text-lg mx-auto flex my-4 mt-8">
                Continue
              </button>
            </div>
          </Modal>
        </div>
      </div> */}
    </div>
  );
};

export default Cancelled;
